import { Component, Input } from '@angular/core';
import { AbstractNgModelComponent } from 'src/app/components/base/abstract-ng-model/abstract-ng-model.component';

@Component({
  selector: 'app-workorder-card-search',
  templateUrl: './workorder-card-search.component.html',
  styleUrls: ['./workorder-card-search.component.scss'],
})
export class WorkorderCardSearchComponent extends AbstractNgModelComponent {
  @Input() placeholder = '';
  value = '';
}
